import type { IButtonLoaderProps } from "@components/atoms/loader/types";
import "ldrs/dotPulse";
import { useThemeVariable } from "@/theme";

export function ButtonLoader({ size, color }: IButtonLoaderProps) {
  const defaultColor = color || "primary-dark";
  const name = defaultColor?.includes("fix")
    ? `--rgb-${defaultColor}`
    : `--theme-${defaultColor}`;
  const { color: themeColor } = useThemeVariable(name);

  return <l-dot-pulse size={size || "36"} speed={"1"} color={themeColor} />;
}
